import React, {FC} from 'react'
import {toAbsoluteUrl} from '../../../../../../_metronic/helpers'

const StartPageWrapper: FC = () => {
  return (
    <>
      <div className='row mt-2 m-0'>
        <div className='col-sm-12 col-lg-4 mt-2 p-0'>
          {/* <KTCard shadow className=' w-100 h-100'> */}
          <div className='card_welcome p-2'>
            <h1 className='mb-0'>
              Bienvenidos a <strong>HOTELERÍA</strong>{' '}
            </h1>
          </div>
          {/* </KTCard> */}
        </div>
        <div className='col-sm-12 col-lg-6 mt-2 p-0'>
          {/* <KTCard shadow className=' w-100 '> */}
          <div className='welcome_image'>
            <img alt='welcome_image' src={toAbsoluteUrl('/media/img/inicio.jpg')} />
          </div>
          {/* </KTCard> */}
        </div>
      </div>
    </>
  )
}

export default StartPageWrapper
